import $ from "jquery";
import {
  capitalizeFirstLetter,
  parseFormData,
  XHRInterceptor,
} from "../utils/utility";

const contactHostForm = () => {
  const el = {
    main: ".modal-contact-host-form",
    contactHostFrom: ".review-form-block",
  };

  const init = () => {
    if (!$(el.main).length && !$(el.contactHostFrom).length) return;
    handlerXhrInterceptor();
  };

  const handlerXhrInterceptor = () => {
    let isHostContactXhr = false;
    let isContactHostXhr = false;

    XHRInterceptor.enable({
      onSend: ({ data, abort }) => {
        const parsedData = parseFormData(data);

        // Handle Host Contact (On Single Room Page)
        if (parsedData.action == "homey_host_contact") {
          const isValid = handlerHostContactForm();

          if (!isValid) {
            $(".homey-icon-loading-half").hide();
            abort();
          }

          isHostContactXhr = true;
        }

        // Handle Contact Host (On Profile Page)
        if (parsedData.action == "homey_contact_host") {
          const isValid = handlerContactHostForm();

          if (!isValid) {
            $(".homey-icon-loading-half").hide();
            abort();
          }

          isContactHostXhr = true;
        }
      },
      onComplete: ({ response }) => {
        const parserResponse = JSON.parse(response);

        // Handler Success Submit
        if (isHostContactXhr && parserResponse.success) {
          // Reset input value after submit success
          const $msgContainer = $(".homey_contact_messages");
          setTimeout(() => {
            $msgContainer.empty();
            $msgContainer.append(
              `<p class="success text-success">Thank you for reaching out! Your message has been successfully sent!</p>`
            );
            // Reset input values
            $(`${el.main} input[type="checkbox"]`).prop("checked", false);
          }, 0);

          setTimeout(() => {
            window.location.reload();
          }, 500);
        }

        // Handler Success Submit
        if (isContactHostXhr && parserResponse.success) {
          // Reset input value after submit success
          const $msgContainer = $("#form_messages");
          setTimeout(() => {
            $msgContainer.empty();
            $msgContainer.append(
              `<p class="success text-success">Thank you for reaching out! Your message has been successfully sent!</p>`
            );
            // Reset input values
            $(
              `${el.contactHostFrom} .form-group input, ${el.contactHostFrom} .form-group textarea`
            ).val("");
            $(`${el.main} input[type="checkbox"]`).prop("checked", false);
          }, 0);

          setTimeout(() => {
            window.location.reload();
          }, 500);
        }
      },
    });
  };

  const handlerHostContactForm = () => {
    const inputs = $(
      `${el.main} .form-group input, ${el.main} .form-group textarea`
    );
    let isValid = true;

    $(inputs.get().reverse()).each(function () {
      const input = $(this);
      const value = input.val().trim();
      const inputType = input.attr("type");
      const inputName = input.attr("name");
      const $msgContainer = $(".homey_contact_messages");

      if (!value) {
        isValid = false;

        $msgContainer.empty();
        $msgContainer.append(
          `<p class="error text-danger">${capitalizeFirstLetter(
            inputName
          )} field cannot be empty.</p>`
        );
      }

      if (inputType === "email" && value) {
        const emailPattern = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

        if (!emailPattern.test(value)) {
          isValid = false;
          $msgContainer.empty();
          $msgContainer.append(
            '<p class="error text-danger">Incorrect email format</p>'
          );
        }
      }
    });

    return isValid;
  };

  const handlerContactHostForm = () => {
    const inputs = $(
      `${el.contactHostFrom} .form-group input, ${el.contactHostFrom} .form-group textarea`
    );
    let isValid = true;

    $(inputs.get().reverse()).each(function () {
      const input = $(this);
      const value = input.val().trim();
      const inputType = input.attr("type");
      const inputName = input.attr("name");
      const $msgContainer = $("#form_messages");

      if (!value) {
        isValid = false;

        $msgContainer.empty();
        $msgContainer.append(
          `<p class="error text-danger">${capitalizeFirstLetter(
            inputName
          )} field cannot be empty.</p>`
        );
      }

      if (inputType === "email" && value) {
        const emailPattern = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

        if (!emailPattern.test(value)) {
          isValid = false;
          $msgContainer.empty();
          $msgContainer.append(
            '<p class="error text-danger">Incorrect email format</p>'
          );
        }
      }
    });

    return isValid;
  };

  init();
};

try {
  contactHostForm();
} catch (e) {
  console.error("MI Gallery : ", e);
}
